var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-editer',{attrs:{"render":_vm.randerArray,"modelData":_vm.data,"handleLoad":_vm.handleLoad},on:{"update:modelData":function($event){_vm.data=$event},"update:model-data":function($event){_vm.data=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }